module.exports = __webpack_public_path__ + "img/ar.0795ec3f.svg";